import Http from "../libs/http";
import Marco from "../marco";
import Log from "../libs/common/log";
export default {
    methods: {
        /**
         * 查询数据字典
         */
        fetchDataDic(dicttypelist,callback,self) {
            const that = this;
            Http.post(
                Marco.api.getDictsForPage,
                {
                    dicttypelist: dicttypelist
                },
                data => {
                    // Log.success(JSON.stringify(data));
                    callback(data);
                },
                errorDesc => {
                    Log.normal('字典查询:' + JSON.stringify(errorDesc));
                },
                error => {
                    Log.error('字典查询:' + JSON.stringify(error));
                },
                self
            );
        }
    }
}